export default "__VITE_ASSET__i3OKnHdR__"